<template>
  <button
   
    type="button"
    aria-label="Clear"
    :class="computedClasses"
    @mousedown.prevent="handleClick"
    @touchstart.prevent="handleClick"
  >
    <TIcon
      :icon="['fal', 'xmark']"
      :size="iconSize"
    />
  </button>
</template>

<script setup lang="ts">
import type { ClearButtonVariant } from '~/components/form/input/clear-button/types'
import type { IconSize } from '~/components/_tailwind/icon/types'

const props = withDefaults(defineProps<{
  variant?: ClearButtonVariant
  iconSize?: IconSize
}>(), {
  variant: 'clear',
  iconSize: 'md',
})

const emit = defineEmits<{
  click: []
}>()

const computedClasses = computed(() => [
  'size-6 cursor-pointer rounded-full flex items-center justify-center text-gray-950',
  {
    'bg-gray-100 hover:bg-gray-50': props.variant === 'muted',
    'hover:bg-white': props.variant === 'clear',
  },
])

function handleClick() {
  emit('click')
}
</script>
